import { render } from "./TotalCustomers.vue?vue&type=template&id=1daccd8f&ts=true"
import script from "./TotalCustomers.vue?vue&type=script&lang=ts"
export * from "./TotalCustomers.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__